module.exports = __webpack_public_path__ + "media/images/markitup/stroke-51631ead986d7606eb3689bbd3bcda22.png";